const isOnDegreePage = (pathname: string): boolean => {
  return pathname === '/degrees' || pathname === '/degrees/';
};

export default isOnDegreePage;
